module.exports = __webpack_public_path__ + "img/promote_thumbnail-400x300.157f12b9.jpg";